import { takeLatest, call, put } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { getCompareRequest, getCompareResponse } from '../../slices/compare';
import {
  setCarTripSearchParam,
  setCruiseSearchParam,
  setFlightTripSearchParam,
  setHotelTripSearchParam,
} from '../../slices/tripSearch';
import getFiltersFromTrip from '../../../helpers/getFiltersFromTrip';

function* getCompareWorker({ payload: { id } }) {
  try {
    const url = `/compare/get?id=${id}`;

    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data && data.id) {
      yield put(
        getCompareResponse({
          data: {
            ...data,
            cruiseOptions: [...data.compareTravelOptions.cruiseOptions],
            hotelOptions: [...data.compareTravelOptions.hotelOptions],
            flightOptions: [...data.compareTravelOptions.flightOptions],
            carOptions: [...data.compareTravelOptions.carOptions],
            tourOptions: [...data.compareTravelOptions.tourOptions],
          },
        }),
      );
      if (data.compareTravelOptions.cruiseOptions) {
        yield put(
          setCruiseSearchParam({
            filters: getFiltersFromTrip(data.compareTravelOptions),
            staterooms: getFiltersFromTrip(data.compareTravelOptions).staterooms,
          }),
        );
      }
      if (data.compareTravelOptions.hotelOptions) {
        yield put(setHotelTripSearchParam({ ...getFiltersFromTrip(data.compareTravelOptions) }));
      }
      if (data.compareTravelOptions.flightOptions) {
        yield put(setFlightTripSearchParam({ ...getFiltersFromTrip(data.compareTravelOptions) }));
      }
      if (data.compareTravelOptions.carOptions) {
        yield put(setCarTripSearchParam({ ...getFiltersFromTrip(data.compareTravelOptions) }));
      }
    } else {
      yield put(getCompareResponse({ error: `Compare not found related to ${id}.` }));
    }
  } catch (error) {
    let errorMessage = 'There is problem with your request. please try again.';
    if (error && error.response && error.response.data) {
      errorMessage = `${error.response.data.title} ${error.response.data.detail}`;
    }
    yield put(
      getCompareResponse({
        error: errorMessage,
      }),
    );
  }
}

function* getCompareWatcher() {
  yield takeLatest(getCompareRequest.toString(), getCompareWorker);
}

export default getCompareWatcher;
